import { RouteRecordRaw } from 'vue-router';
import { AdminBranchEditPage } from '@/pages/admin';

export const routeName = 'AdminEditarFilial';

export const route: RouteRecordRaw = {
  path: 'filiais/:id',
  name: routeName,
  component: AdminBranchEditPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Filiais',
    permissions: [{ action: 'manageBranches', subject: 'Admin' }],
  },
};
